export default [
  'n.slavov@toki.bg',
  'v.atanasova@toki.bg',
  'i.dimitrov@toki.bg',
  'e2e.impersonation@toki.bg',
  'a.rekalov@toki.bg',
  'g.nankova@toki.bg',
  'l.velichkov@toki.bg',
  'p.georgieva@toki.bg',
  't.dobreva@toki.bg',
  'a.taneva@toki.bg',
];
